<template>
    <div class="mainbody modulewrap" ref="mainbox">
        <div class="learnwrap">
            <div class="learnmainwrap" ref="videowrap">
                <template v-if="topiccur.video">
                    <div class="learnmp4" v-if="topiccur.video.indexOf('.mp4')>=0">
                        <video :src="topiccur.video" :poster="topiccur.poster" controls autoplay controlslist="nodownload" @contextmenu.prevent=""></video>
                    </div>

                    <div v-else class="learnmain">
                        <div class="winmask" v-if="isshowmask"></div>
                        <div class="learnvideo" id="learnvideo"></div>
                    </div>
                </template>

            </div>


            <div :class="['learnside',$store.getters.issmall?'':issidefirst?'transiderightdefault':isshowside?'transiderightback':'transideright']">
                <div class="learnsidebtn">
                    <ul>
                        <li><a href="#" :class="{cs:infoindex==1}" @click="infoindex=1"><i class="iconfont icon-menu"><span>{{$common.dicword('topic')}}</span></i></a></li>
                        <li v-if="!infodata.isdemand"><a href="#" :class="{cs:infoindex==2}" @click="infoindex=2"><i class="iconfont icon-image-text"><span>{{$common.dicword('intro')}}</span></i></a></li>
                        <li v-if="!infodata.isdemand"><a href="#" :class="{cs:infoindex==3}" @click="infoindex=3"><i class="iconfont icon-edit"><span>{{$common.dicword('activity')}}</span></i></a></li>
                        <li><a href="#" @click="gotopic(-1)"><i class="iconfont icon-arrow-up-bold"><span>{{$common.dicword('prevtopic')}}</span></i></a></li>
                        <li><a href="#" @click="gotopic(1)"><i class="iconfont icon-arrow-down-bold"><span>{{$common.dicword('nexttopic')}}</span></i></a></li>

                        <li v-if="!$store.getters.issmall"><a href="#" class="b" @click="showside"><i :class="['iconfont',' icon-arrow-right-bold',issidefirst?'': isshowside ? 'transitionrotateback':'transitionrotate']"></i></a></li>

                    </ul>
                </div>
                <div class="learnsideinfo">
                    <div class="learncourseinfo">
                        <div class="cover">
                            <img :src="infodata.cover" />
                        </div>
                        <dl class="info">
                            <dt>{{$common.langinfo(infodatalevel.title,infodatalevel.title_en)}}</dt>
                            <dd class="a">{{$common.langinfo(infodata.title,infodata.title_en)}}</dd>
                            <dd class="b">{{$common.langinfo(topiccur.title,topiccur.title_en)}}</dd>
                        </dl>
                    </div>

                    <div class="infocon" v-show="infoindex==1">
                        <myScroll class="scroll">
                            <div class="list">
                                <a href="#" v-for="(item,index) in infodatatopic" :key="item.id" :class="{cs:topicid==item.id}" @click.prevent="showtopic(item.id)">
                                    <dl>
                                        <dt>{{$common.basic.padleft(index+1)}}</dt>
                                        <dd class="a">{{$common.langinfo(item.title,item.title_en)}}</dd>
                                        <dd class="b" v-if="item.duration">{{$common.basic.chint2timewithsecond(item.duration)}}</dd>
                                    </dl>
                                </a>
                            </div>
                        </myScroll>
                    </div>
                    <div class="infocon" v-show="infoindex==2">
                        <myScroll class="scroll">
                            <span v-html="$common.langinfo(topiccur.content,topiccur.content_en)"></span>
                            <div class="linkright">
                                <a :href="topiccur.attach" target="_blank" v-if="topiccur.attach">{{$common.dicword('material')}}{{$common.dicword('download')}}</a>
                            </div>
                        </myScroll>
                    </div>
                    <div class="infocon" v-show="infoindex==3">
                        <myScroll class="scroll" v-if="topiccur.conhw">
                            <span v-html="$common.langinfo(topiccur.conhw,topiccur.conhw_en)"></span>
                            <div class="linkright" v-if="!infodatahw.isread && $store.getters.isstu">
                                <ffupload :fileurl="upfileurl" @update:fileurl="upattach" :updata="{'mediatype':'zip','filesize':100}" :uptitle="$common.dicword('uploadwork')"></ffupload>
                            </div>
                            <template v-if="$common.basic.isobjexist(infodatahw)">
                                <div class="linesp"></div>
                                <div class="attach">
                                    <a :href="infodatahw.attach" target="_blank">
                                        <svg class="icon" aria-hidden="true">
                                            <use xlink:href="#icon-yasuobao"></use>
                                        </svg>{{$common.basic.dateformat(infodatahw.dateupload)}}
                                    </a>

                                </div>
                                <template v-if="infodatahw.conmark">
                                    <div class="hwbacktitle">{{$common.dicword('recommend')}}</div>
                                    <div class="hwback" v-html="infodatahw.conmark">

                                    </div>
                                </template>

                            </template>

                        </myScroll>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'learn',
        data() {
            return {
                topicid: 1,
                topiccur: {},
                isinit: false,
                infodata: {},
                infodatahw: {},
                infodatacollege: {},
                infodatalevel: {},
                infodatatopic: [],
                videourl: '',
                infoindex: 1,
                issidefirst: true,
                isshowside: true,
                upfileurl: '',
                myinterval: '',
                learnid: 0,
                infoheight: 100,
                isshowmask: true,

                lastlearndata: {},
                playduration: 0,
                videocurtime: 0
            }
        },
        computed: {
            smalllearninfo: function () {
                if (this.$store.getters.issmall) {
                    return { 'height': this.infoheight + 'px' };
                }
                else {
                    return {};
                }
            }
        },
        methods: {
            getdata(v) {
                this.isinit = true;
                let jsondata = { 'postdata': { 'act': 'tea_course', 'id': v }, 'needid': true };
                this.$common.post(jsondata, res => {
                    this.infodata = res.infodata;

                    this.infodatacollege = res.infodatacollege;
                    this.infodatalevel = res.infodatalevel;
                    this.infodatatopic = res.infodatatopic;
                    this.$emit("setcollegeid", this.infodatacollege.isprivate == 1 ? 0 : this.infodatacollege.id);

                    this.$store.commit('SET_TOPNAV', res.infodatacollege.isdemand ? 500 : 200);
                });
            },
            gettopic() {
                this.isshowmask = true;
                let jsondata = { 'postdata': { 'act': 'tea_learn', 'id': this.topicid, 'data': { 'learnid': this.learnid } }, 'needid': true };
                this.$common.post(jsondata, res => {
                    this.infodatahw = res.infodatahw;
                    res.infodata.x_iscomplete = false;
                    this.topiccur = res.infodata;
                    this.learnid = res.learnid;
                    this.lastlearndata = res.infodatalearn;
                    if (this.$common.basic.isobjexist(res.infodatalearn)) {
                        this.videocurtime = res.infodatalearn.duration;
                    }

                    if (res.ismine == 0) {
                        this.$router.replace('/member');
                    }
                    if (!this.isinit) {
                        this.getdata(res.infodata.courseid);
                    }
                    if (this.topiccur.video.indexOf('.mp4') < 0) {
                        this.initPolyv(this.loadPolyv);
                    }
                });
            },
            showside() {
                this.issidefirst = false;
                this.isshowside = !this.isshowside;
            },
            gotopic(v) {
                let objindex = this.infodatatopic.findIndex(item => item.id == this.topicid) + v;
                if ((objindex >= 0) && (objindex < this.infodatatopic.length)) {
                    this.topicid = this.infodatatopic[objindex].id;
                    this.gettopic();
                }
            },
            showtopic(v) {

                this.topicid = v;
                this.gettopic();
                return false;
            },
            upattach(v) {
                if (v) {
                    if (v.indexOf('blob:http') < 0) {
                        let jsondata = {
                            'postdata': { 'act': 'tea_learn_hw', 'id': this.topicid, 'data': { 'attach': v } }, 'msg': ''
                        };
                        this.$common.post(jsondata, res => {
                            this.infodatahw = res.infodata;
                        });

                    }
                }

            },
            learnsave: function () {
                if (this.learnid > 0) {
                    let jsondata = {
                        'postdata': {
                            'act': 'tea_learn_save', 'id': this.learnid, 'data': { 'iscomplete': this.topiccur.x_iscomplete ? 1 : 0, 'duration': this.playduration }
                        }, 'msg': ''
                    };
                    this.$common.post(jsondata, () => {
                    });
                }

            },
            initPolyv(callback) {
                let vodPlayerJs = 'https://player.polyv.net/script/player.js';
                //let vodPlayerJs = 'https://player.polyv.net/resp/vod-player-drm/latest/player.js';
                //let vodPlayerJs = 'https://player.polyv.net/resp/vod-player/latest/player.js';
                if (!window.polyvPlayer) {
                    const myScript = document.createElement('script');
                    myScript.setAttribute('src', vodPlayerJs);
                    myScript.onload = callback;
                    document.body.appendChild(myScript);
                } else {
                    callback();
                }
            },
            loadPolyv() {

                const polyvPlayer = window.polyvPlayer;
                if (this.topiccur.video) {
                    let jsondata = {
                        'postdata': {
                            'api': 'polyv', 'act': 'polyvplay', 'id': this.topiccur.id, 'data': { 'vid': this.topiccur.video }
                        }, 'msg': ''
                    };

                    this.$common.post(jsondata, res => {
                        this.PolyvClear();

                        this.$nextTick(() => {
                            this.player = polyvPlayer({
                                'wrap': '#learnvideo',
                                'width': '100%',
                                'height': '100%',
                                'useH5Page': true,
                                'x5VideoType': 'h5',
                                'forceH5': true,
                                'full_page_screen': false,
                                'pictureInPicture': false,
                                'rightMenu': [],
                                'loading_bg_img': this.topiccur.poster,
                                'vid': res.infodata.vid,
                                'playsafe': res.infodata.token,
                                'ts': res.infodata.ts,
                                'sign': res.infodata.sign
                            });
                            this.player.on('s2j_onPlayerInitOver', () => {
                                this.isshowmask = false;

                                if (this.videocurtime > 0) {
                                    this.player.j2s_seekVideo(this.videocurtime);
                                    this.videocurtime = 0;
                                }
                                this.PolyvCurrenttime();
                            });

                            this.player.on('s2j_onPlayOver', () => {
                                this.topiccur.x_iscomplete = true;
                                this.learnsave();
                            });
                        });
                    });
                }


            },
            PolyvCurrenttime() {
                if (window.polyvPlayer) {
                    if (!this.isshowmask) {
                        this.playduration = Math.round(this.player.j2s_getCurrentTime());
                    }
                    else {
                        this.playduration = 0;
                    }
                }
                else {
                    this.playduration = 0;
                }

            },
            PolyvSeek(v) {
                let isplay = false;
                if (window.polyvPlayer) {
                    if (!this.isshowmask) {
                        isplay = true;
                    }
                }

                if (isplay) {
                    this.player.j2s_seekVideo(v);
                }
                else {
                    this.initPolyv(this.loadPolyv);
                }
            },
            PolyvClear() {
                if (this.player) {
                    this.player.destroy();
                }
            }
        },
        mounted() {
            if (this.$common.checklogin()) {
                this.topicid = this.$common.basic.chstr2int(this.$route.params.id);
                this.gettopic();
            }

            this.myinterval = window.setInterval(() => {
                this.learnsave();
            }, 1000 * 60);

            window.addEventListener('beforeunload', this.learnsave);
        },
        beforeDestroy() {
            this.learnsave();
            window.removeEventListener('beforeunload', this.learnsave);
            window.clearInterval(this.myinterval);
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
        }
    }
</script>
